module.exports = __webpack_public_path__ + "img/selected-adrift-in-the-harbor-2.7b262822.webp";